import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import InvisibleRecaptcha from '../invisible-recaptcha';
import { MediaQuery as MQ } from '../../media-query';
import moment from 'moment';

class Component extends BaseComponent {
    constructor() {
        super();

        if (!MQ.isMobile()) {
            this.recaptchaInstance;
            this.setState({ recaptchaCompleted: false });
        }

        this.dialog;

        this.setState({
            name: null,
            nameError: null,
            email: null,
            emailError: null,
            birthdate: null,
            birthdateError: null,
            password: null,
            password_verify: null,
            passwordError: null,
            dh_optin: false,
            wrs_optin: false,
            privacy_policy: false,
            subscribe_lists: [],
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.route != this.props.route) {
            if (this.dialog) {
                if (nextProps.route == 'signup' && !nextProps.user.logged_in && !this.props.user.logged_in) {
                    if (nextProps.user.email && nextProps.user.password) {
                        this.props.trackEvent(['Modal', 'show', 'Signup']);
                        this.dialog.showModal();
                        return false;
                    }

                    this.props.routeTo('login');
                } else if (nextProps.route == 'signup') {
                    this.props.routeTo('');
                } else if (this.props.route == 'signup'){
                    this.props.trackEvent(['Modal', 'close', 'Signup']);
                    this.dialog.close();
                    return false;
                }
            }
        }

        if (!MQ.isMobile() && !this.state.recaptchaCompleted && nextState.recaptchaCompleted) {
            this.userSignup();
        }

        return true;
    }

    componentDidMount() {
        const that = this;
        this.dialog = document.getElementById('signup-modal');
        dialogPolyfill.registerDialog(this.dialog); //eslint-disable-line no-undef

        this.dialog.addEventListener('keydown', (e) => {
            if (e.keyCode == 13) {
                this.validate();
            } else if (e.keyCode == 27) {
                e.preventDefault();
                this.close();
            }
        });

        this.dialog.addEventListener('click', (e) => {
            if (e.target.tagName == 'DIALOG') {
                that.close();
            }
        });
    }

    render({ product }) {
        let title = 'Let Us Get to Know You';
        let subtitle = 'Personalize your experience by telling us a bit about yourself…';
        let button_text = 'ENTER';

        if (product && product.type) {
            title = `your ${product.type} awaits!`;
            button_text = `GET MY ${product.type}!`.toUpperCase();
        }

        return (
            <responsive-signup-modal>
                <dialog id='signup-modal'>
                    <dialog-header>
                        <button class='button-close' onClick={this.close}>×</button>
                        <h1>{title}</h1>
                        <h5>{subtitle}</h5>
                    </dialog-header>
                    <dialog-content>
                        <row>
                            <column class='is-7'>
                                <label>Your Name</label>
                                <input
                                  type='text'
                                  class={this.state.nameError ? 'error' : ''}
                                  onKeyup={this.setName}
                                />
                                {this.renderError(this.state.nameError)}
                            </column>
                            <column class='is-5'>
                                <label>Your Birth Date</label>
                                <input
                                  type='date'
                                  placeholder='mm/dd/yyyy'
                                  class={this.state.birthdateError ? 'error' : ''}
                                  onChange={this.setBirthdate}
                                />
                                {this.renderError(this.state.birthdateError)}
                            </column>
                        </row>
                        <row>
                            <column>
                                <label class='checkbox'>
                                    <input
                                      type='checkbox'
                                      name='dh_optin'
                                      checked={this.state.dh_optin}
                                      onChange={this.setDHOptin}
                                    />
                                    Get my FREE daily horoscope emails
                                </label>
                            </column>
                        </row>
                        <row>
                            <column>
                                <label class='checkbox'>
                                    <input
                                      type='checkbox'
                                      name='wrs_optin'
                                      checked={this.state.wrs_optin}
                                      onChange={this.setWRSOptin}
                                    />
                                    Get my FREE weekly horoscope emails
                                </label>
                            </column>
                        </row>
                        {this.renderPPC()}
                        <div class='has-text-centered'>
                            {this.renderRecaptcha()}
                            <button class='button-modal' onClick={this.validate}>
                                {button_text}
                            </button>
                        </div>
                        {this.renderTOS()}
                    </dialog-content>
                </dialog>
            </responsive-signup-modal>
        );
    }

    renderPPC = () => {
        if (!this.props.ppc) {
            return (
                <row>
                    <column>
                        <label class={`checkbox ${this.state.privacyPolicyError ? 'error' : ''}`}>
                            <input
                              type='checkbox'
                              name='privacy_policy'
                              value='1'
                              onChange={this.setPrivacyPolicy}
                            />
                            I agree to Tarot.com's updated <a href='/privacy-policy' target='_blank'>Privacy
                            Policy</a> and <a href='/terms-of-use' target='_blank'>Terms of Use</a>
                        </label>
                        {this.renderError(this.state.privacyPolicyError)}
                    </column>
                </row>
            );
        }

        return null;
    }

    renderRecaptcha = () => {
        if (!MQ.isMobile()) {
            return (
                <InvisibleRecaptcha
                  ref={e => this.recaptchaInstance = e}
                  onChange={this.handleChanged}
                  onExpired={this.handleExpired}
                />
            );
        }

        return null;
    }

    renderTOS = () => {
        if (this.props.ppc) {
            return (
                <row>
                    <column>
                        <label class='checkbox has-text-centered'>
                            <br />
                            By continuing, you accept our <a href='/privacy-policy' target='_blank'>Privacy Policy</a>
                            &nbsp;and <a href='/terms-of-use' target='_blank'>Terms of Use</a>.
                        </label>
                    </column>
                </row>
            );
        }

        return null;
    }

    close = () => {
        this.props.trackEvent(['Modal', 'close', 'Signup']);
        this.props.routeTo('');
    }

    setName = (e) => {
        this.setState({
            name: e.target.value,
        });
    }

    setBirthdate = (e) => {
        this.setState({
            birthdate: e.target.value,
        });
    }

    setDHOptin = (e) => {
        this.setState({
            dh_optin: e.target.checked,
        });
    }

    setWRSOptin = (e) => {
        this.setState({
            wrs_optin: e.target.checked,
        });
    }

    setPrivacyPolicy = (e) => {
        this.setState({
            privacy_policy: e.target.checked,
        });
    }

    renderError = (error) => {
        if (error) {
            return (
                <span class='error-message'>{error}</span>
            );
        }

        return null;
    }

    validate = () => {
        const nameError = this.state.name ? null : 'Please enter your name.';
        const birthdateError = this.validateBirthdate();
        let privacyPolicyError = null;

        if (!this.props.ppc) {
            privacyPolicyError = this.state.privacy_policy ? null : 'Please accept before continuing';
        }

        this.setState({
            nameError: nameError,
            birthdateError: birthdateError,
            privacyPolicyError: privacyPolicyError,
        });

        if (!nameError && !birthdateError && !privacyPolicyError) {
            let subscribe_lists = ['ipe'];

            if (this.state.dh_optin) {
                subscribe_lists.push('dailyhoroscope');
            }

            if (this.state.wrs_optin) {
                subscribe_lists.push('weekly_love');
            }

            this.setState({
                subscribe_lists: subscribe_lists,
            });

            if (!MQ.isMobile()) {
                this.dialog.close();
                this.recaptchaInstance._component.execute();
            } else {
                this.userSignup();
            }
        }
    }

    validateBirthdate = () => {
        if (!this.state.birthdate) {
            return 'Please enter your birth date';
        } else if (
            this.state.birthdate.match(/^\d{2,4}-\d{2}-\d{2}$/)
            ||
            this.state.birthdate.match(/^\d{1,2}\/\d{1,2}\/\d{2,4}$/)
            ||
            this.state.birthdate.match(/^\d{2}-\d{2}-\d{2,4}$/)
        ) {
            const thirteen_years_ago = moment().subtract(13, 'years');
            if (moment(this.state.birthdate).isAfter(thirteen_years_ago)) {
                return 'You must be at least 13 years of age to signup.';
            }

            return null;
        }

        return 'Birthday format is mm/dd/yyyy';
    }

    handleChanged = () => {
        this.setState({ recaptchaCompleted: true });
    }

    handleExpired = () => {
        this.setState({ recaptchaCompleted: false });
    }

    userSignup = () => {
        this.props.userSignup({
            first_name: this.state.name,
            display_name: this.state.name,
            email: this.props.user.email,
            password: this.props.user.password,
            password_verify: this.props.user.password,
            signup_gateway: '#signup',
            signup_bonus: true,
            signup_url: window.location.href,
            account_type_id: 1,
            award_pfero: true,
            birth_date: moment(this.state.birthdate).format('YYYY-MM-DD'),
            timezone: (new Date().getTimezoneOffset() / 60) * -1,
            subscribe_lists: this.state.subscribe_lists,
            privacy_policy: true,
        });
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
    product: state.product,
    user: state.user,
    ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: route => dispatch({ type: 'route:to', payload: route }),
    userSignup: payload => dispatch({ type: 'user:signup-api', payload: payload }),
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
    setCookie: payload => dispatch({ type: 'cookie:set', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);


// WEBPACK FOOTER //
// ./app/components/responsive/signup-modal.js